import { createAsyncThunk } from '@reduxjs/toolkit';
// oxlint-disable-next-line cian-eslint-compat/no-restricted-paths
import { resolveUserRole } from '../../../shared/services/userRole';
import { setUserRole } from '../../../shared/slices/userRoleReducer';
import { TUserRole } from '../../../shared/types/currentUser';
import { IThunkApi } from '../../../shared/types/redux';

export const getUserRoleAction = createAsyncThunk<TUserRole, void, IThunkApi>(
  'user/getUserRoleAction',
  async (_, thunkApi) => {
    const {
      dispatch,
      extra: { httpApi, logger, config },
    } = thunkApi;
    const userRole = await resolveUserRole({ config, httpApi, logger });
    dispatch(setUserRole(userRole));

    return userRole;
  },
);
